const RavensburgerWaltzLead = {
    name: "Ravensburger Waltz",
    bpm: 198,
    signature: "6/8",
    introMeasures: 8,
    pattern: [

    ]
};

export default RavensburgerWaltzLead;